import React from 'react'
import FileUploadButton from '../../../../file/upload/FileUploadButton'
import FileBdList from '../../../../file/bd/FileBdList'
import { useSelector } from 'react-redux'

const WriteOffActFilesBlock = ({ name, tableOwnerId, tableOwnerType = 'writeOffActs', type }) => {
    
    const writeOffAct = useSelector(state => state.writeOff.writeOffAct)

  return (
    <div className='fileListBlock'>
        <div className='fileListBlock__header'>
            <p>
                {name}
            </p>
            <FileUploadButton
                tableOwnerId={tableOwnerId}
                tableOwnerType={tableOwnerType}
                type={type}
            />
        </div>
        
        <FileBdList 
            type={type}
            files={writeOffAct && writeOffAct.files ? writeOffAct.files : []}
        />
    </div>
  )
}

export default WriteOffActFilesBlock